export const GlampartnerPaymentRegistry = {
  createGlambox:{
    url: "/financial/payment/glambox",
    method: ["POST"]
  },
  create:{
    url: "/financial/payment/others",
    method: ["POST"],
    required:["paymentTypeId", "dateFrom", "value"]
  },
  updatePaymentRegistry:{
    url:"/financial/payment/registry",
    method: ["PUT"]
  },
  getPaymentTypes:{
    url:"/financial/payment/paymentTypes",
    method: ["GET"]
  },
  getPaymentTypesDetail:{
    url:"/financial/payment/paymentTypes/detail",
    method: ["GET"]
  },
}